var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5231 19.7625H2.94907C2.43276 19.7625 1.9376 19.5595 1.57251 19.1982C1.20742 18.8369 1.00232 18.3468 1.00232 17.8358V10.1289H2.30015V17.8358C2.30015 18.0061 2.36852 18.1695 2.49022 18.2899C2.61191 18.4104 2.77697 18.478 2.94907 18.478H18.5231C18.6952 18.478 18.8603 18.4104 18.9819 18.2899C19.1036 18.1695 19.172 18.0061 19.172 17.8358V10.1289H20.4698V17.8358C20.4698 18.3468 20.2647 18.8369 19.8997 19.1982C19.5346 19.5595 19.0394 19.7625 18.5231 19.7625Z",
    fill: "#BF1F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.385 1.49609H10.0872V14.3409H11.385V1.49609Z",
    fill: "#BF1F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7361 15.4066C10.651 15.4076 10.5666 15.391 10.4884 15.3578C10.4102 15.3246 10.3398 15.2756 10.2819 15.2139L6.60901 11.5788L7.51749 10.6797L10.7361 13.8524L13.9807 10.6797L14.8892 11.5788L11.2163 15.2139C11.1555 15.2789 11.0809 15.3299 10.9979 15.3632C10.9149 15.3965 10.8255 15.4113 10.7361 15.4066Z",
    fill: "#BF1F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e8ccb1ec838e41644caf4e8e4635d054.svg";
export { ForwardRef as ReactComponent };